<div class="bc-page">

  <!-- ── LOADING ──────────────────────────────────────────────── -->
  <div class="bc-loading" *ngIf="!ready">
    <div class="bc-loading__icon"><mat-icon>account_balance</mat-icon></div>
    <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
    <p class="bc-loading__text">Cargando formulario…</p>
  </div>

  <ng-container *ngIf="ready">

    <!-- ── HEADER ─────────────────────────────────────────────── -->
    <div class="bc-header">
      <div class="bc-header__icon"><mat-icon>account_balance</mat-icon></div>
      <div>
        <h1 class="bc-header__title">{{ bankCharges.uid ? 'Editar gasto bancario' : 'Nuevo gasto bancario' }}</h1>
        <p class="bc-header__sub">{{ bankCharges.uid ? 'Modifica los datos del gasto' : 'Registra un gasto bancario' }}</p>
      </div>

      <button mat-flat-button class="bc-btn-save" (click)="save()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>

    <!-- ── BODY ───────────────────────────────────────────────── -->
    <div class="bc-body">
      <div class="bc-grid">

        <!-- COLUMNA IZQUIERDA: Datos del gasto -->
        <div class="bc-left">

          <!-- SECCIÓN: Datos principales -->
          <div class="bc-section">
            <div class="bc-section__head">
              <mat-icon>receipt</mat-icon>
              <span>Datos del gasto</span>
            </div>
            <div class="bc-section__body">

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Concepto</mat-label>
                <input matInput [(ngModel)]="bankCharges.concept" name="bankCharges.concept"
                  [matAutocomplete]="autoIConcept" [formControl]="conceptCtrl" required>
                <mat-autocomplete #autoIConcept="matAutocomplete">
                  <mat-option *ngFor="let concept of filteredConcepts | async; trackBy: trackByIndex" [value]="concept">
                    {{ concept }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <div class="bc-two-col">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Importe</mat-label>
                  <input type="text" matInput name="bankCharges.amount" required
                    [(ngModel)]="bankCharges.amount" numberDecimalsDirective>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Fecha</mat-label>
                  <input matInput [matDatepicker]="date" name="bankCharges.date"
                    [(ngModel)]="bankCharges.date" required>
                  <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
                  <mat-datepicker #date></mat-datepicker>
                </mat-form-field>
              </div>

              <app-input inputType="text" placeholder="Cuenta contable" name="bankCharges.expenseAccount"
                [(ngModel)]="bankCharges.expenseAccount"></app-input>

            </div>
          </div>

          <!-- SECCIÓN: Observaciones -->
          <div class="bc-section">
            <div class="bc-section__head">
              <mat-icon>description</mat-icon>
              <span>Observaciones</span>
            </div>
            <div class="bc-section__body">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Observaciones / Información adicional</mat-label>
                <textarea matInput name="comment" [(ngModel)]="bankCharges.comment" rows="4"></textarea>
              </mat-form-field>
            </div>
          </div>

        </div>

        <!-- COLUMNA DERECHA: Cuenta destino y proyecto -->
        <div class="bc-right">

          <!-- SECCIÓN: Cuenta destino -->
          <div class="bc-section">
            <div class="bc-section__head">
              <mat-icon>account_balance_wallet</mat-icon>
              <span>Cuenta destino</span>
            </div>
            <div class="bc-section__body">

              <app-autocomplete-select [items]="destinations_options"
                [(selectedItemId)]="bankCharges.destinationIsBankAccount"
                [idField]="'id'" [displayField]="'name'"
                placeholder="Tipo de cuenta destino" class="w-100">
              </app-autocomplete-select>

              <ng-container *ngIf="bankCharges.destinationIsBankAccount === true">
                <app-autocomplete-select [items]="bankAccounts"
                  [(selectedItemId)]="bankCharges.bankAccountUid"
                  [idField]="'uid'" [displayFields]="['bank', 'iban']"
                  placeholder="Cuenta bancaria" class="w-100">
                </app-autocomplete-select>
              </ng-container>

              <ng-container *ngIf="bankCharges.destinationIsBankAccount === false">
                <app-autocomplete-select [items]="polizaCredito"
                  [(selectedItemId)]="bankCharges.polizaCreditoId"
                  [idField]="'uid'" [displayFields]="['banco', 'iban']"
                  placeholder="Póliza de crédito" class="w-100">
                </app-autocomplete-select>
              </ng-container>

            </div>
          </div>

          <!-- SECCIÓN: Proyecto (condicional) -->
          <div class="bc-section" *ngIf="isProjectEnable && (projects?.length > 0 || expenseProjectTypes?.length > 0)">
            <div class="bc-section__head">
              <mat-icon>folder</mat-icon>
              <span>Proyecto</span>
            </div>
            <div class="bc-section__body">

              <app-autocomplete-select *ngIf="projects?.length > 0"
                [items]="projects" [(selectedItemId)]="bankCharges.projectUid"
                [idField]="'id'" [displayField]="'display'"
                placeholder="Proyecto" class="w-100">
              </app-autocomplete-select>

              <app-autocomplete-select *ngIf="expenseProjectTypes?.length > 0"
                [items]="expenseProjectTypes" [(selectedItemId)]="bankCharges.expenseProjectTypeUid"
                [idField]="'id'" [displayField]="'display'"
                placeholder="Tipo de gasto del proyecto" class="w-100">
              </app-autocomplete-select>

            </div>
          </div>

        </div>

      </div>
    </div>

  </ng-container>

</div>
